var allowed_keys = [
  'size',
  'size_in_cm',
  'thigh_circumference_inch',
  'calf_circumference_inch',
  'shaft_height_inch',
  'shoelace_length_in'
],   
    meta_rename_obj ={
      'size': 'SIZE',
      'size_in_cm': 'SIZE (CM)',
      'calf_circumference_inch':'CALF CIRC. (IN)',
      'calf_circumference_cm':'CALF CIRC. (CM)',
      'thigh_circumference_inch':'THIGH CIRC. (IN)',
      'thigh_circumference_cm':'THIGH CIRC. (CM)',
      'shaft_height_inch':'SHAFT HEIGHT (IN)',
      'shaft_height_cm':'SHAFT HEIGHT (CM)',
      'shoelace_length_in': 'SHOELACE LENGTH (IN)'
    },
    mytable = $('<table></table>').attr({ id: "size-chart",class:"table table-striped" }),
    thead = $('<thead></thead>').appendTo(mytable),
    thead_tr = $('<tr></tr>').appendTo(thead),
    tbody = $('<tbody></tbody>').appendTo(mytable),
    new_meta_obj = {};
	$("#tabs-s2").append(mytable);
$(allowed_keys).each(function(i,key) {
  if(key in metafields){
    var arr = metafields[key].split(',');
    new_meta_obj[key] = arr.sort(function(a, b){
      return parseFloat(a) - parseFloat(b);
    });
    
    var thead_name = (meta_rename_obj[key] ? meta_rename_obj[key] : key.replace(/_/g,' ').toUpperCase());
    $('<th></th>').text(thead_name).appendTo(thead_tr);
  }
});

var sizes = {};
$.each(new_meta_obj.size, function(i, el){
  if(!(el in sizes) && el != ''){
    sizes[el] = i;
    var row = $('<tr></tr>').appendTo(tbody);
    for(key in new_meta_obj){
      if(new_meta_obj[key].length > 0){
        var cols = new_meta_obj[key],
            td_txt = (!cols[i] || cols[i] == '' ? '' : cols[i]);
        $('<td></td>').text(td_txt).appendTo(row); 
      }
    }
  }
});

if(mytable.length > 0) mytable.appendTo("#size-table");	 